module.exports = __webpack_public_path__ + "img/bljqr.65d50be0.jpg";